module.exports = __webpack_public_path__ + "static/images/containers/ClanManagement/components/MembersControlBlock/images/remove_members.7508563a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanManagement/components/MembersControlBlock/images/remove_members.png
// module id = 3057
// module chunks = 11